// IMPORTANT: Import this file at the very top of main.tsx
// This initializes Sentry before any other code runs
import * as Sentry from '@sentry/react';

const environment = import.meta.env.VITE_ENVIRONMENT || 'development';

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment,

    // Release tracking (use git commit SHA from CI/CD)
    release: import.meta.env.VITE_GIT_COMMIT_SHA || 'unknown',

    // Tag to distinguish from backend and admin frontend
    initialScope: {
      tags: {
        app: 'customer-frontend',
      },
    },

    // Disable performance monitoring to stay on free tier
    tracesSampleRate: 0,

    // Disable session replay (paid feature)
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,

    // Ignore noisy errors to stay under free tier quota (5k events/month)
    ignoreErrors: [
      // Browser quirks
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',

      // Network errors (transient, not bugs)
      'Network request failed',
      'Failed to fetch',
      'Load failed',
      'NetworkError',
      'AbortError',

      // Code splitting failures (usually network issues)
      'ChunkLoadError',
      'Loading chunk',
      'Importing a module script failed',

      // Third-party script errors
      'Script error',
      'Script error.',

      // GeoComply expected errors (already filtered in console)
      'GeoComply',
      'geocomply',

      // Auth errors (expected user flow, not bugs)
      /401/,
      /403/,
      'Unauthorized',
      'Forbidden',
    ],

    // Filter URLs to ignore (third-party scripts, extensions)
    denyUrls: [
      // Browser extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
      /^safari-extension:\/\//i,

      // Common third-party scripts
      /gtag\/js/,
      /analytics\.js/,
      /hotjar/,
      /intercom/,
    ],
  });

  if (import.meta.env.DEV) {
    console.log(`[Sentry] Initialized for environment: ${environment}`);
  }
}

// Export Sentry for use in other parts of the app
export { Sentry };
